import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import CollectionsBootstrap from 'modules/ats/lib/SettingsCollectionsBootstrap'
import { AtsContextProvider } from 'modules/ats/lib/atsContext'
import { useAtsEnabled } from 'modules/ats/lib/atsEnabled'

const RootPage = () => {
  const { atsEnabled } = useAtsEnabled()

  const authorizeFn = () => {
    return atsEnabled
  }

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <CollectionsBootstrap>
        <AtsContextProvider>
          <Outlet />
        </AtsContextProvider>
      </CollectionsBootstrap>
    </AuthorizeUser>
  )
}

export default RootPage
